import React, { useState } from 'react'
import PropTypes from 'prop-types'
import MultiSelectionDropdown from 'components/multiSelectDropdown'
import { FiltersContentContainer } from '../style'
import { getSelectedOptions } from '../index'
import qs from 'query-string'

export const getSpeciesListUrl = (selectedSpecies = [], selectedClasses = []) => {
  return qs.stringify({
    taxonId: selectedSpecies.toString(),
    className: selectedClasses.toString()
  }, { skipEmptyString: true, skipNull: true })
}

const SpeciesFiltersContent = ({
  item,
  updateFilters,
  filterTitle,
  getSpecieOptions,
  specieOptions,
  setSpecieOptions,
  taxonomyClassOptions = []
}) => {
  const [speciesList, setSpeciesList] = useState(item.speciesList || [])
  const [classList, setClassList] = useState(item.classList || [])
  const [specieQuery, setSpecieQuery] = useState('')

  const handleChangeSpecieList = (e) => {
    setSpeciesList(e)
    updateFilters({
      ...item,
      speciesList: e,
      classList,
      selectedSpecieOptions: getSelectedOptions(e, specieOptions),
      url: getSpeciesListUrl(e, classList)
    }, filterTitle)
    setSpecieOptions(getSelectedOptions(e, specieOptions))
  }

  const handleChangeClassList = (e) => {
    setClassList(e)
    updateFilters({
      ...item,
      speciesList,
      classList: e,
      selectedSpecieOptions: getSelectedOptions(speciesList, specieOptions),
      url: getSpeciesListUrl(speciesList, e)
    }, filterTitle)
  }

  const handleRemoveUnCheckedOptions = () => {
    setSpecieOptions(getSelectedOptions(speciesList, specieOptions))
  }

  const handleSearchSpecie = (e) => {
    setSpecieQuery(e)
    if (e.length > 4) {
      return getSpecieOptions(e)
    }

    if (e.length === 4) {
      setSpecieOptions(getSelectedOptions(speciesList, specieOptions))
    }
  }

  return (
    <FiltersContentContainer>
      <MultiSelectionDropdown
        dataTest="Species"
        marginTop='16px'
        label='species'
        secondStepOptions={specieOptions}
        value={speciesList}
        saveChanges={handleChangeSpecieList}
        infoTooltip='specieFilterHint'
        inputValue={specieQuery}
        onInputChange={handleSearchSpecie}
        isSearchable={true}
        placeholder='searchByScientificName'
        selectAllOption={false}
        closeFunc={handleRemoveUnCheckedOptions}
      />
      <MultiSelectionDropdown
        dataTest="Taxonomic Class"
        marginTop='16px'
        label='className'
        secondStepOptions={taxonomyClassOptions}
        value={classList}
        saveChanges={handleChangeClassList}
        infoTooltip='taxonomyClassFilterHint'
        isSearchable={true}
        placeholder='selectMultipleOptions'
        selectAllOption={false}
      />
    </FiltersContentContainer>
  )
}

SpeciesFiltersContent.propTypes = {
  item: PropTypes.shape({
    speciesList: PropTypes.arrayOf(PropTypes.number),
    classList: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  updateFilters: PropTypes.func.isRequired,
  filterTitle: PropTypes.string.isRequired,
  getSpecieOptions: PropTypes.func.isRequired,
  specieOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number
  })).isRequired,
  setSpecieOptions: PropTypes.func.isRequired,
  taxonomyClassOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  }))
}

SpeciesFiltersContent.defaultProps = {
  taxonomyClassOptions: []
}

export default SpeciesFiltersContent
